



































































import EditionModal from "../core/Modals/EditionModal.vue";
import { BulletinDeSalaireApi } from "../api/BulletinDeSalaireApi";
import { BulletinDeSalaire } from "../models/BulletinDeSalaire";
import { UserApi } from "../api/UserApi";
import { User } from "../models/User";
import BulletinDeSalaireModalEdit from "./BulletinDeSalaireModalPartials/BulletinDeSalaireModalEdit.vue";
import BulletinDeSalaireModalDisplay from "./BulletinDeSalaireModalPartials/BulletinDeSalaireModalDisplay.vue";
import BulletinDeSalaireModalPdfViewer from "./BulletinDeSalaireModalPartials/BulletinDeSalaireModalPdfViewer.vue";

export default {
    name: "BulletinDeSalaireModal",
    components: {
        EditionModal,
        BulletinDeSalaireModalEdit,
        BulletinDeSalaireModalDisplay,
        BulletinDeSalaireModalPdfViewer,
    },
    props: {
        bulletinDeSalaireId: Number,
        isNew: Boolean,
        forceEditing: Boolean,
    },
    data() {
        return {
            showModal: false,
            bulletinDeSalaire: null,
            fetching: true,
            editing: false,
            BulletinDeSalaireApi: new BulletinDeSalaireApi(),
            UserApi: new UserApi(),
            editable: true,
            showPdfInEditMode: false,
        };
    },
    created() {
        var self = this;

        self.UserApi.getCurrentUser().then(function (user) {
            self.editable = !user.hasRole(User.ERole.Syndic);
        });
    },
    watch: {
        bulletinDeSalaireId: function (newVal): void {
            var self = this;

            self.showModal = _.isNumber(newVal);
            if (self.showModal) {
                self.fetching = true;
                self.BulletinDeSalaireApi.get(self.bulletinDeSalaireId, {
                    include: "files,employe",
                }).then(function (res) {
                    self.bulletinDeSalaire = res;
                    self.fetching = false;
                });
            }
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.bulletinDeSalaire = new BulletinDeSalaire({});
                    this.creationModal();
                }
            },
        },
        forceEditing: function (newVal) {
            this.editing = newVal;
        },
    },
    methods: {
        closeModal: function (data): void {
            this.editing = false;
            this.showModal = false;
            this.$emit("close-modal", data);
        },
        saveBulletinDeSalaire: function (): Promise<BulletinDeSalaire> {
            var self = this;
            return self.BulletinDeSalaireApi.save(self.bulletinDeSalaire).then(
                function (res) {
                    self.$emit("data-saved", self.bulletinDeSalaire);
                    return res;
                }
            );
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.editing = true;
        },
        togglePdfVisibility: function (): void {
            this.showPdfInEditMode = !this.showPdfInEditMode;
        },
    },
};
